exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@mixin clearfix {\n:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n}\n@mixin scrollBar {\n::-webkit-scrollbar-track-piece {\n    background: #d3dce6;\n}\n::-webkit-scrollbar {\n    width: 6px;\n}\n::-webkit-scrollbar-thumb {\n    background: #99a9bf;\n    border-radius: 20px;\n}\n}\n@mixin relative {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.app-wrapper[data-v-628c34e1] {\n@include clearfix;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.app-wrapper.mobile.openSidebar[data-v-628c34e1] {\n  position: fixed;\n  top: 0;\n}\n.drawer-bg[data-v-628c34e1] {\n  background: #000;\n  opacity: 0.3;\n  width: 100%;\n  top: 0;\n  height: 100%;\n  position: absolute;\n  z-index: 999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-628c34e1","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/feige/Layout.vue
// module id = 322
// module chunks = 75